module.exports = __webpack_public_path__ + "5f9028697fed81327fb9900e262a9796.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-8.png
// module id = 2052
// module chunks = 0